import { createContext, useContext, useRef, useState } from "react";
import { ScrollView, ScrollViewProps, View } from "react-native";

interface Props extends ScrollViewProps {
  children: React.ReactNode;
}

interface ResidentLayoutContextValue {
  scrollTo: (view: View) => void;
}

const ResidentLayoutContext = createContext<ResidentLayoutContextValue>(
  {} as ResidentLayoutContextValue,
);

export function ResidentLayoutProvider({ children, ...props }: Props) {
  const scrollRef = useRef<ScrollView>(null);
  const [scrollPos, setScrollPos] = useState(0);

  const scrollTo = (view: View) => {
    view.measure((_x, _y, _width, _height, _pageX, pageY) => {
      scrollRef.current?.scrollTo({
        y: pageY - 200 + scrollPos,
        animated: true,
      });
    });
  };
  return (
    <ResidentLayoutContext.Provider value={{ scrollTo }}>
      <ScrollView
        {...props}
        ref={scrollRef}
        className="flex-1"
        scrollEventThrottle={20}
        onScroll={(ev) => {
          setScrollPos(ev.nativeEvent.contentOffset.y);
        }}
        contentContainerClassName={`min-h-full ${props.contentContainerClassName}`}
      >
        {children}
      </ScrollView>
    </ResidentLayoutContext.Provider>
  );
}

export function useResidentLayoutContext() {
  const context = useContext(ResidentLayoutContext);
  if (!context) {
    throw new Error(
      "ResidentProviderContext must be used within a ResidentProvider",
    );
  }
  return context;
}
